<template>
  <!-- <div style="display: block;"> -->
    <!-- v-show="dragGeneralState.active" -->
    <div
      id="drag-preview"
      class="drag-el"
      :style="{
        left: dragGeneralState.x + 'px',
        top: dragGeneralState.y + 'px',
      }"
    >
      <app-icon
        class="drag-el__icon"
        :name="dragIconName"
        width="18px"
        color="#979797"
        cursor="pointer"
      />
      <div class="drag-el__text">
        {{ dragGeneralState.name }}
      </div>
      <div class="drag-el__count">
        {{ dragGeneralState.count }}
      </div>
    </div>
    <div
      v-if="dragGeneralState.count > 1"
      class="drag-el"
      :style="{
        zIndex: 99,
        left: dragGeneralState.x + 4 + 'px',
        top: dragGeneralState.y + 4 + 'px',
      }"
    >
      <app-icon
        class="drag-el__icon"
        :name="dragIconName"
        width="18px"
        color="#979797"
        cursor="pointer"
      />
      <div class="drag-el__text">
        {{ dragGeneralState.name }}
      </div>
    </div>
  <!-- </div> -->
</template>

<script setup lang="ts">
import { computed, inject } from "vue";
import { DragGeneralState } from "@/models/interfaces/file/file-model";
import AppIcon from "../ui-kit/icon/AppIcon.vue";

const dragGeneralState = inject<DragGeneralState>("dragGeneralState", {
  name: "",
  type: "",
  count: 0,
  active: false,
  x: 0,
  y: 0,
});

const typeIconMap: Record<string, string> = {
  // папка
  folder: "folder-closed",

  // документы
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  xlsm: "file-excel",
  xlsb: "file-excel",
  xltx: "file-excel",
  xltm: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  ppsx: "file-powerpoint",
  potx: "file-powerpoint",
  pdf: "file-pdf",

  // изображения
  jpg: "file-image",
  jpeg: "file-image",
  png: "file-image",
  gif: "file-image",
  bmp: "file-image",
  tiff: "file-image",
  svg: "file-image",
  ai: "file-image",
  eps: "file-image",
  webp: "file-image",
  raw: "file-image",
  psd: "file-image",
  ico: "file-image",

  // видео
  mp4: "file-video",
  mov: "file-video",
  mkv: "file-video",
  avi: "file-video",
  wmv: "file-video",
  flv: "file-video",
  webm: "file-video",
  mpeg: "file-video",
  mpg: "file-video",

  // аудио
  mp3: "file-audio",
  wav: "file-audio",
  flac: "file-audio",
  ogg: "file-audio",
  m4a: "file-audio",
  wma: "file-audio",
  ape: "file-audio",
  mid: "file-audio",
  opus: "file-audio",

  // архивы
  zip: "file-archive",
  rar: "file-archive",
  "7z": "file-archive",
  tar: "file-archive",
  gz: "file-archive",
  gzip: "file-archive",
  cab: "file-archive",
  sit: "file-archive",

  // текст
  txt: "file-text",
  log: "file-text",
  csv: "file-text",
  odt: "file-text",
  rtf: "file-text",
  epub: "file-text",
  fb2: "file-text",
  mobi: "file-text",

  // код
  html: "file-code",
  htm: "file-code",
  php: "file-code",
  asp: "file-code",
  jsp: "file-code",
  xhtml: "file-code",
  xml: "file-code",
  css: "file-code",
  js: "file-code",
};

const dragIconName = computed(() => {
  return typeIconMap[dragGeneralState.type] || "file-universal";
});
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";

.drag-el {
//   transform: translate(100px, 100px);
  box-sizing: border-box;

  display: flex;
  //   flex-direction: column;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;

  position: fixed;

  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
  border-radius: 12px;

  //   max-width: 350px;
  white-space: nowrap;
  overflow: visible;
  text-overflow: ellipsis;

  pointer-events: none;
  z-index: 100;

  &__text {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #4d4d4d;
  }

  &-lot-count {
    z-index: 9998;
  }

  &__icon {
    display: inline;
  }

  .drag-el__count {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);

    display: flex;
    align-items: center;
    justify-content: center;

    min-width: 22px;
    height: 22px;
    padding: 0 6px;

    border-radius: 9999px;
    background-color: $color-on-accent;
    color: $background-white;

    z-index: 200;
  }
}
</style>
